<template>
  <div>
    <div class="flex flex-wrap bg-gray-700 overflow-auto">
      <div class="py-5 px-8 border-r border-b w-1/3 border-gray-800 text-white cursor-pointer">
        <div class="uppercase whitespace-no-wrap">Bruttovolumen</div>
        <div class="text-2xl mt-2 whitespace-no-wrap">{{ (keyFigures.revenue / 100) | price }}</div>
      </div>
      <div class="py-5 px-8 border-r border-b w-1/3 border-gray-800 text-white cursor-pointer">
        <div class="uppercase whitespace-no-wrap">Rückerstattungsvolumen</div>
        <div class="text-2xl mt-2 whitespace-no-wrap">
          {{ (keyFigures.refundedRevenue / 100) | price }}
        </div>
      </div>
      <div class="py-5 px-8 border-r border-b w-1/3 border-gray-800 text-white cursor-pointer">
        <div class="uppercase whitespace-no-wrap">Nettovolumen</div>
        <div class="text-2xl mt-2 whitespace-no-wrap">
          {{ (keyFigures.netRevenue / 100) | price }}
        </div>
      </div>
      <div class="py-5 px-8 border-r border-b w-1/3 border-gray-800 text-white cursor-pointer">
        <div class="uppercase whitespace-no-wrap">Verkaufte Tickets</div>
        <div class="text-2xl mt-2 whitespace-no-wrap">{{ keyFigures.ticketCount }}</div>
      </div>
      <div class="py-5 px-8 border-r border-b w-1/3 border-gray-800 text-white cursor-pointer">
        <div class="uppercase whitespace-no-wrap">Erstattete Tickets</div>
        <div class="text-2xl mt-2 whitespace-no-wrap">{{ keyFigures.refundedTicketCount }}</div>
      </div>
      <div class="py-5 px-8 border-r border-b w-1/3 border-gray-800 text-white cursor-pointer">
        <div class="uppercase whitespace-no-wrap">Bestellungen</div>
        <div class="text-2xl mt-2 whitespace-no-wrap">{{ keyFigures.orderCount }}</div>
      </div>
      <div class="py-5 px-8 border-r border-b w-full border-gray-800 text-white cursor-pointer">
        <div class="uppercase whitespace-no-wrap">Ausstehendes Erstattungsvolumen</div>
        <div class="text-2xl mt-2 whitespace-no-wrap">
          {{ (keyFigures.outstandingRevenue / 100) | price }}
        </div>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-gray-500
                      uppercase
                      tracking-wider
                    "
                  >
                    Bestellung
                  </th>
                  <th
                    scope="col"
                    class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-gray-500
                      uppercase
                      tracking-wider
                    "
                  >
                    Datum
                  </th>
                  <th
                    scope="col"
                    class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-gray-500
                      uppercase
                      tracking-wider
                    "
                  >
                    Veranstaltung
                  </th>
                  <th
                    scope="col"
                    class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-gray-500
                      uppercase
                      tracking-wider
                    "
                  >
                    Anzahl Tickets
                  </th>
                  <th
                    scope="col"
                    class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-gray-900
                      uppercase
                      tracking-wider
                    "
                  >
                    Summe
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(order, orderIdx) in sortedOrders"
                  :key="order.uuid"
                  :class="orderIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                >
                  <td
                    class="
                      px-6
                      py-4
                      whitespace-nowrap
                      text-sm
                      font-medium
                      text-gray-900
                      hover:underline
                    "
                  >
                    <router-link :to="{ name: 'order', params: { id: order.uuid } }">
                      #{{ order.uuid }}
                    </router-link>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ order.date | shortDate }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ order.event_title }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ order.ticket_count }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{ (order.ticket_sum / 100) | price }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reportsClient from '@/api/merchant/reports';
import dayjs from 'dayjs';

export default {
  props: {
    dateFrom: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
    dateTo: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
  },

  filters: {
    price(value) {
      var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      });

      return formatter.format(value);
    },
    timeLeftMinutes(value) {
      return Math.floor((value % (60 * 60)) / 60);
    },
    timeLeftSeconds(value) {
      return ('0' + Math.floor(value % 60).toString()).slice(-2);
    },
    shortDate(value) {
      return dayjs(value).format('DD MMM YYYY');
    },
  },

  data() {
    return {
      keyFigures: {
        orders: [],
      },
    };
  },

  methods: {
    loadKeyFigures() {
      reportsClient
        .keyFigures({ from: this.dateFrom, to: this.dateTo })
        .then(({ data }) => (this.keyFigures = data.data));
    },
  },

  computed: {
    sortedOrders() {
      return this.keyFigures.orders.sort(function (a, b) {
        return new Date(b.date) - new Date(a.date);
      });
    },
  },

  watch: {
    dateFrom: {
      handler: function () {
        this.loadKeyFigures();
      },
      immediate: true,
    },
    dateTo: {
      handler: function () {
        this.loadKeyFigures();
      },
    },
  },
};
</script>
